import { _setClient } from '@carto/react-core'
import { setClient as setApiClient } from '@carto/api-client'

export enum Client {
  Builder = 'builder',
  Workspace = 'workspace',
  WorkflowsUI = 'workflows-ui',
  WorkflowsSchedule = 'workflows-schedule'
}

let client = Client.Workspace

export function getClient() {
  return client
}

export function setClient(c: Client) {
  client = c
  _setClient(c)
  setApiClient(c)
}
